import { ChangeEvent } from "react";
import { Grid } from "@mui/material";
import { CloudDownload } from "@mui/icons-material";
import { DataGrid } from "@mui/x-data-grid";
import { FormattedMessage, useIntl } from "react-intl";
import { addMonths, endOfMonth, startOfMonth, subMonths } from "date-fns";

import { DateTimeInput } from "@dzambalaorg/mui-inputs-picker";
import { SearchWithFilters } from "@dzambalaorg/mui-form-search";
import { Breadcrumbs, PageHeader } from "@dzambalaorg/mui-page-layout";
import { useFetchQuery } from "@dzambalaorg/react-hooks";
import { IReferralEvents } from "@framework/types";
import { formatItem } from "@framework/exchange";
import { IPaginationResult } from "@dzambalaorg/types-collection";
import { Button } from "@dzambalaorg/ui-kit";

import { referralReportColumnsCreator } from "./schemas";

const initialSearchValues = {
  startTimestamp: startOfMonth(subMonths(new Date(), 1)).toISOString(),
  endTimestamp: endOfMonth(addMonths(new Date(), 1)).toISOString(),
};

// TODO rework to use assets
export const ReferralReport = () => {
  const { isLoading, take, skip, onChangePage, allRows, totalCount } = useFetchQuery<
    IPaginationResult<IReferralEvents>
  >("/referral/report/search", void 0, void 0, initialSearchValues);

  const { formatMessage } = useIntl();

  // const { fn } = useApiCall(async (api, values) => {
  //   return api.fetchFile({
  //     url: "/referral/report/export",
  //     data: values,
  //   });
  // });

  const handleExport = (): Promise<void> => {
    // return fn(void 0, search);
    return Promise.resolve();
  };

  // prettier-ignore
  const columns = referralReportColumnsCreator(formatMessage);

  return (
    <Grid>
      <Breadcrumbs path={["dashboard", "referral", "referral.report"]} />

      <PageHeader message="pages.referral.report.title">
        <Button startIcon={<CloudDownload />} onClick={handleExport}>
          <FormattedMessage id="form.buttons.export" />
        </Button>
      </PageHeader>

      <SearchWithFilters initialValues={initialSearchValues}>
        <Grid container spacing={2} alignItems="flex-end">
          <Grid size={{ xs: 6 }}>
            <DateTimeInput name="startTimestamp" />
          </Grid>
          <Grid size={{ xs: 6 }}>
            <DateTimeInput name="endTimestamp" />
          </Grid>
        </Grid>
      </SearchWithFilters>

      <DataGrid
        pagination
        paginationMode="server"
        rowCount={totalCount}
        paginationModel={{ page: skip / take, pageSize: take }}
        onPaginationModelChange={({ page }) => onChangePage({} as ChangeEvent<unknown>, page)}
        pageSizeOptions={[5, 10, 25]}
        loading={isLoading}
        columns={columns}
        rows={allRows.map((reward: IReferralEvents) => ({
          id: reward.id,
          account: reward.account,
          item: formatItem(reward.item),
          price: formatItem(reward.price),
          contract: reward.contract!.title,
          createdAt: reward.createdAt,
        }))}
      />
    </Grid>
  );
};
